import { useContext } from "react";

import { GoalsContext } from "@contexts/GoalsContext";

export const useGoalsContext = () => {
  return useContext(GoalsContext);
};
